
const ProductsData = [{
  "_id": {
    "$oid": "686a6d1b8b57bc96a92d9e1f"
  },
  "title": "METER PANEL",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754648151/Meter_PANEL_img_owbwql_c_pad_w_500_h_500_b5h5bx.png",
  "description": "Our Meter Panels are designed to deliver reliable, accurate, and safe power distribution. Built with high-quality components, they ensure precise monitoring, easy accessibility, and long-lasting performance—whether it’s for a small building or a high-rise complex. With our Meter Panels, you can seamlessly monitor power consumption and manage distribution with complete confidence.",
  "brand": "Best Deal Electricals",
  "features": "- Accurate metering for all applications.\n- Easy installation and maintenance.\n- Durable and compliant with industry standards.\n- Suitable for residential, commercial, and industrial use.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a6fca8b57bc96a92d9e27"
  },
  "title": "PLC Automation Panel",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754647098/PLC_AUTOMATION_PANEL_ccpzct.png",
  "description": "Our PLC Automation Panels are engineered to provide smart, reliable, and efficient control solutions for a wide range of industrial processes. Designed with advanced PLC technology, these panels ensure seamless automation, precise monitoring, and improved productivity. From small machinery control to large-scale industrial automation, our panels are customized to meet specific application needs with flexibility and accuracy.",
  "brand": "Best Deal Electricals",
  "features": "- Advanced automation control.\n- Robust and durable construction.\n- Easy installation and integration.\n- Compliance with industrial safety standards.\n- Suitable for diverse industrial environments.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a6fe48b57bc96a92d9e29"
  },
  "title": "Power Factor Panel",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754648059/power_factor_euymm6_c_pad_w_500_h_500_ixrxxa.png",
  "description": "Our Power Factor Panels are designed to improve energy efficiency, reduce electricity costs, and ensure reliable power quality in industrial and commercial setups. By automatically managing and correcting the power factor, these panels minimize energy losses, enhance system performance, and prevent penalties from utility providers.",
  "brand": "Best Deal Electricals",
  "features": "- Improves energy efficiency.\n- Manages reactive power.\n- Enhances voltage stability.\n- Durable and reliable design.\n- Suitable for commercial and industrial use.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a6ff38b57bc96a92d9e2b"
  },
  "title": "MAIN LINE LT PANEL",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754647092/Main_Lt_Distribution_Panel_hnqs30.png",
  "description": "The Main Line LT Panel serves as the central hub of power distribution, delivering electricity safely and efficiently from the transformer to various equipment and sub-panels. Designed with robust construction and advanced protection features, it ensures smooth operation, overload protection, and uninterrupted power supply. Our LT panels are engineered to handle high electrical loads with precision, making them ideal for industrial, commercial, and residential applications.",
  "brand": "Best Deal Electricals",
  "features": "- Heavy duty construction for long lasting reliability.\n- Overload and short circuit protection.\n- User friendly installation and maintenance.\n- Ideal for commercial, industrial, and infrastructure projects.\n- Conforms to IEC and IS safety standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a701c8b57bc96a92d9e2d"
  },
  "title": "DIMMER TYPE AIR COOL SERVO VOLTAGE STABILIZERS",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754472249/SERVO_VOLTAGE_STABILIZERS_rfbuyb.jpg",
  "description": "Dimmer Type Servo Voltage Stabilizers from Best Deal Electricals are engineered for precise voltage regulation in environments prone to fluctuations. These stabilizers utilize advanced dimmer-based technology to ensure smooth voltage correction, protecting sensitive equipment and enhancing performance reliability across commercial and industrial setups.",
  "brand": "Best Deal Electricals",
  "features": "- High accuracy voltage correction using dimmer technology.\n- Reduces energy wastage and improves equipment lifespan.\n- Ideal for voltage sensitive applications.\n- Robust construction for continuous operation.\n- Complies with IS and IEC standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a702b8b57bc96a92d9e2f"
  },
  "title": "LINEAR TYPE OIL COOL SERVO VOLTAGE STABILIZERS",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754472290/Linnear_TYPE_SERVO_VOLTAGE_STABILIZERS_hbqqrb.jpg",
  "description": "Linear Type Servo Voltage Stabilizers by Best Deal Electricals offer seamless voltage regulation with high efficiency and fast response time. Designed for critical applications, these stabilizers ensure stable output voltage to protect equipment from fluctuations, improving operational reliability in industrial and commercial settings.",
  "brand": "Best Deal Electricals",
  "features": "- Fast and precise linear voltage correction.\n- Low maintenance and silent operation.\n- High efficiency and durability.\n- Suitable for sensitive and heavy duty electrical loads.\n- Manufactured as per IS and IEC standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a70378b57bc96a92d9e31"
  },
  "title": "HT to LT TRANSFORMER",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1750312686/HT_to_LT_TRANSFORMER_g9rf06.png",
  "description": "The Distribution Transformer from Best Deal Electricals is designed to efficiently step down high-voltage electricity for safe distribution across commercial, residential, and industrial infrastructures. Engineered for high performance, energy efficiency, and long service life, it ensures reliable power delivery even under fluctuating load conditions.",
  "brand": "Best Deal Electricals",
  "features": "- High efficiency with minimal energy loss.\n- Oil cooled and air cooled options available.\n- Rugged design for long operational life.\n- Suitable for outdoor and indoor installations.\n- Compliant with IS 1180 and IEC standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a70408b57bc96a92d9e33"
  },
  "title": "ISOLATION TRANSFORMER",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1749630283/ISOLATION_TRANSFORMER_im4yac.webp",
  "description": "The Isolation Transformer from Best Deal Electricals is designed to provide galvanic isolation between primary and secondary windings, enhancing safety and protecting sensitive equipment from electrical noise, surges, and spikes. It is ideal for laboratories, hospitals, CNC machinery, and precision instruments.",
  "brand": "Best Deal Electricals",
  "features": "- Complete electrical isolation for enhanced safety.\n- Reduces electrical noise and disturbances.\n- Improves system stability and equipment protection.\n- Built for continuous duty in sensitive environments.\n- Adheres to IS and IEC safety norms.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a70498b57bc96a92d9e35"
  },
  "title": "STEP-DOWN TRANSFORMER",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1750312842/STEP-DOWN_TRANSFORMER_ocqhjy.png",
  "description": "The Step-Down Transformer from Best Deal Electricals is engineered to convert high-voltage electricity to lower, usable levels for safe operation of electrical devices. Ideal for both industrial and commercial applications, it ensures energy-efficient voltage conversion and long-term reliability.",
  "brand": "Best Deal Electricals",
  "features": "- Efficient voltage step down for varied load requirements.\n- Compact and durable construction.\n- Ideal for industrial machinery and commercial equipment.\n- Thermal and overload protection built in.\n- Complies with IS and IEC standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a70538b57bc96a92d9e37"
  },
  "title": "ONLINE UPS",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1749629646/Online_UPS_g4ftwi.png",
  "description": "The Online UPS from Best Deal Electricals provides uninterrupted power supply with zero transfer time, making it ideal for critical applications. It ensures continuous and clean power delivery, protecting sensitive equipment from voltage fluctuations, surges, and power outages.",
  "brand": "Best Deal Electricals",
  "features": "- Double conversion technology for pure sine wave output.\n- Zero transfer time during power failure.\n- Intelligent battery management for longer backup.\n- LCD display for real time monitoring.\n- Conforms to IEC and IS standards for safety and performance.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a705b8b57bc96a92d9e39"
  },
  "title": "LT/HT CABLES",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1750313480/LT_HT_CABLES_mvkaw1.png",
  "description": "LT/HT Cables from Best Deal Electricals are built for efficient power transmission in low and high tension applications. Engineered with high-grade insulation and conductors, these cables offer superior electrical performance, safety, and longevity in industrial, commercial, and infrastructure projects.",
  "brand": "Best Deal Electricals",
  "features": "- High grade copper/aluminum conductors.\n- XLPE/PVC insulation for thermal and mechanical strength.\n- UV, moisture, and chemical resistant outer sheath.\n- Suitable for underground and overhead installations.\n- Conforms to IS 7098 and IEC standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a70658b57bc96a92d9e3b"
  },
  "title": "ELECTRIC WIRE",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1749627708/ELECTRIC_WIRE_y3ekz6.jpg",
  "description": "Electric Wires from Best Deal Electricals are manufactured using high-quality copper and insulation materials, ensuring efficient current flow and enhanced safety. These wires are ideal for residential, commercial, and industrial wiring needs, offering superior conductivity and long-term reliability.",
  "brand": "Best Deal Electricals",
  "features": "- High conductivity with 99.97% pure copper.\n- Flame retardant and heat resistant insulation.\n- Available in multiple sizes and colors.\n- Suitable for domestic, commercial, and industrial use.\n- Compliant with IS 694 and RoHS standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a706e8b57bc96a92d9e3d"
  },
  "title": "DISTRIBUTION PANEL",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1751732015/distribution_panel_c_crop_w_500_h_500_ncrztk_c_pad_w_500_h_500_vuhcle.jpg",
  "description": "The Distribution Panel from Best Deal Electricals is designed to streamline the safe distribution of electrical power across multiple circuits. Engineered with precision and built for resilience, it is ideal for commercial, residential, and industrial applications. The panel features top-tier components and ensures organized, efficient, and secure power management.",
  "brand": "Best Deal Electricals",
  "features": "- Compact and modular design for space efficiency.\n- Integrated circuit protection for enhanced safety.\n- Simple installation and low maintenance.\n- Supports load balancing and energy efficiency.\n- Built to meet IEC and IS compliance standards.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a707f8b57bc96a92d9e3f"
  },
  "title": "Roof Top Solar System",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1751729232/Roof_top_solar_xb4inc.jpg",
  "description": "Our Roof Top Solar Systems harness the power of the sun to provide clean, renewable energy for residential, commercial, and industrial buildings. Designed for maximum efficiency and durability, they help reduce electricity bills and carbon footprint.",
  "brand": "Best Deal Electricals",
  "features": "- Clean and renewable energy source.\n- Reduces electricity costs.\n- Easy rooftop installation.\n- Low maintenance and long lifespan.\n- Ideal for homes, businesses, and factories.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a70918b57bc96a92d9e41"
  },
  "title": "High Mast Poles",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1751729220/high_mask_pole_ydssif.jpg",
  "description": "Our High Mast Poles are engineered for large-area lighting in highways, stadiums, industrial zones, and public spaces. These poles offer superior illumination, durability, and low maintenance, ensuring long-term performance even in harsh environments.",
  "brand": "Best Deal Electricals",
  "features": "- Suitable for wide area lighting.\n- Weather resistant and corrosion proof.\n- Easy maintenance with lowering head mechanism.\n- Strong and durable construction.\n- Ideal for highways, stadiums, and industrial areas.",
  "__v": 0
},
{
  "_id": {
    "$oid": "686a709d8b57bc96a92d9e43"
  },
  "title": "Solar Street Light",
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1751729239/solar_street_light_iyqvj3.jpg",
  "description": "Our Solar Street Lights provide efficient, eco-friendly lighting solutions using solar energy. Ideal for streets, pathways, parks, and rural areas, they operate independently of the power grid and ensure long-lasting performance with minimal maintenance.",
  "brand": "Best Deal Electricals",
  "features": "- Solar powered and energy efficient.\n- Automatic dusk to dawn operation.\n- Weatherproof and durable design.\n- Low maintenance and long lifespan.\n- Ideal for roads, parks, and remote areas.",
  "__v": 0
}]
export default  ProductsData